/* eslint-disable */
import { getFirestore, doc, addDoc, getDoc, getDocs, setDoc, collection, query, where } from 'firebase/firestore'
import Guest from '@/models/guest'
import Cookie from '@/helpers/cookie'

export default class Group {
  constructor(id, name, code, rsvped, additional) {
    // Constructor should only be used internally by this class.
    this.id = id
    this.name = name
    this.code = code
    this.rsvped = rsvped
    this.additional = additional
    this.members = undefined // Populated on `load()`.
    this._ref = this.ref
    this._collection = this.collection
  }

  toString() {
    return 'Group ('
      + this.id + ', '
      + this.name + ', '
      + this.code + ', '
      + this.rsvped + ', '
      + this.additional + ')'
  }

  static firestoreConverter() {
    return {
      toFirestore: (group) => {
        return {
          name: group.name,
          code: group.code,
          rsvped: group.rsvped,
          additional: group.additional,
        }
      },
      fromFirestore: (snapshot, options) => {
        const data = snapshot.data(options)

        return new Group(
          snapshot.id,
          data.name,
          data.code,
          data.rsvped ? data.rsvped.toDate() : false,
          data.additional,
        )
      }
    }
  }

  get ref() {
    if (!this.id) return null
    if (!this._ref) {
      this._ref = doc(getFirestore(), 'groups', this.id).withConverter(Group.firestoreConverter())
    }
    return this._ref
  }

  get collection() {
    if (!this._collection) {
      this._collection = collection(getFirestore(), 'groups').withConverter(Group.firestoreConverter())
    }
    return this._collection
  }

  static async create(name, guests, additional = false) {
    if (!name) {
      throw new Error('A name is required to create a group.')
    }

    const group = new Group(null, name, null, false, additional)
    const ref = await addDoc(group.collection, group)
    group.id = ref.id
    group.code = group.id?.slice(0,5).toUpperCase()
    group.save()

    if (guests?.length > 0) {
      guests.forEach(async g => await Guest.create(g, group.id))
    }

    return group
  }

  static async get(id) {
    const group = new Group(id)
    const snap = await getDoc(group.ref)
    const result = snap.data()
    await result?.load()
    return result
  }

  async load() {
    const snap = await getDoc(this.ref)
    const result = snap.data()
    if (!result) return false

    this.members = await Guest.getGroupMembers(this.ref)
    return true
  }

  async save() {
    return await setDoc(this.ref, this, {merge: true})
  }

  static async getAll() {
    const group = new Group()
    const snap = await getDocs(group.collection)
    const all = snap.docs.map(doc => doc.data())
    return await Promise.all(
      all.map(async g => {
        await g.load()
        return g
      })
    )
  }

  static async current() {
    const id = Cookie.get('auth')
    if (!id) return false
    const group = await Group.get(id)
    if (!group) return false
    return group
  }

  static async auth(code) {
    // const group = await Group.get(id)
    let group = new Group(null, '_')
    const q = query(group.collection, where('code', '==', code))
    const snap = await getDocs(q)
    if(!snap.empty) {
      group = snap.docs[0].data()
      Cookie.set('auth', group.id, 14)
      return group
    } else {
      return false
    }
  }

  static async rsvped() {
    const group = await Group.current()
    const rsvped = group.members.every(m => typeof m.rsvp === 'boolean')
    group.rsvped = rsvped ? new Date() : false
    group.save()
    return
  }
}